var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M97.1602631,34.1319008h-0.0214462V7.1532702c0-2.37854-1.9071732-4.2857141-4.2857132-4.2857141H65.4245605V2.8461065  H34.1387634v0.0214493H7.1388164c-2.3572211,0-4.2857141,1.9071743-4.2857141,4.2857141v85.7142868  c0,2.3572235,1.928493,4.2857132,4.2857141,4.2857132h85.7142868c2.37854,0,4.2857132-1.9284897,4.2857132-4.2857132V65.4175644  h0.0214462V34.1319008z M93.92453,65.4175644v27.4499893c0,0.5786133-0.4714966,1.071434-1.0714264,1.071434H65.4245605V65.4175644  H34.1387634v28.5214233H7.1388164c-0.5786133,0-1.0714283-0.4928207-1.0714283-1.071434V65.4175644h28.0713749V34.1319008H6.0673881  V7.1532702c0-0.5999322,0.492815-1.0714288,1.0714283-1.0714288h26.9999466v28.0500603h31.2857971V6.0818415h27.4285431  c0.5999298,0,1.0714264,0.4714966,1.0714264,1.0714288v26.9786301H65.4245605v31.2856636H93.92453z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecker);
export default __webpack_public_path__ + "static/media/checker.3901cda9d2f0ef288ada83b23d50741a.svg";
export { ForwardRef as ReactComponent };